module.exports = __webpack_public_path__ + "static/media/MAINTAIN 1.3d6a7293.svg";